import "./vendor.css"

import "jquery";
import "bootstrap";
import "featherlight";
import * as ionRangeSlider from "../node_modules/ion-rangeslider/js/ion.rangeSlider.js";
import * as accounting from "accounting";
import * as slick from "slick-carousel";
import "./vendor/restable";


/* Fix featherlight scrolling on IOs.
   From: https://github.com/noelboss/featherlight/issues/273 */
$.featherlight.defaults.beforeOpen = function() {
    $(document.body).css({
        'top':  '-' + window.scrollY + 'px',
        'position': 'fixed',
        'width': '100%',
        'height': 'inherit'
    });
};

$.featherlight.defaults.afterClose = function() {
    var top = Math.abs(parseInt($(document.body).css('top')));
    $(document.body).css({
        'top': '',
        'position': '',
        'width': '',
        'height': ''
    });

    window.scrollTo(0, top);
};

$(".carousel").slick({
  dots: true,
  infinite: true,
  speed: 300,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 2500,
  centerMode: true,
  slidesToShow: 1,
  focusOnSelect: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      variableWidth: false,
      arrows: false,
      centerMode: true
    }
  }]
});

$(".slider").slick({
    dots: true,
    infinite: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    responsive: [{
        breakpoint: 768,
        settings: {
            variableWidth: false,
            arrows: false,
            slidesToShow: 1
        }
    }]
});

$(".table.table--stacked").ReStable({maxWidth: 768, keepHtml: true});

accounting.settings = {
    currency: {
        symbol : "₽",
        format: "%v %s",
        decimal : ",",
        thousand: " ",
        precision : 2
    },
    number: {
        precision : 0,
        thousand: " ",
        decimal : "."
    }
};

// Initialize calculator
$(document).ready(function(){
    var $amount = $("[name='amount']");

    $amount.val(accounting.formatNumber($amount.val()));

    $(window.location.hash).find(".collapse").collapse("show");

    $("#programsFormPeriod").ionRangeSlider({
        grid: true,
        from: 2,
        values: [
            "до 4 месяцев", "6 месяцев", "1 год", "2 года", "3 года"
        ],
        onChange: function (data) {
            $("#programsFormPeriodValue").val(data.from);
            $(".programs_form").trigger("change");
        }
    });

    $("#programsFormPayments").ionRangeSlider({
        grid: true,
        from: 0,
        values: [
            "Не важно", "Ежемесячно", "В конце срока", "Капитализация"
        ],
        onChange: function (data) {
            $("#programsFormPaymentsValue").val(data.from);
            $(".programs_form").trigger("change");
        }
    });

    $(".programs_form").on("change keyup", function(){
        calculate();
    });

    calculate();
});

const calculate = function() {
    var $amount    = $("[name='amount']");
    var $period    = $("#programsFormPeriodValue");
    var $payments  = $("#programsFormPaymentsValue");
    var $pensioner = $("[name='pensioner']");
    var amount = accounting.unformat($amount.val());
    var period = parseInt($period.val());
    var payments = parseInt($payments.val());
    var pensioner = $pensioner.prop("checked");

    if (amount >= 1400000) {
        $("#specialOffer").show();
    } else {
        $("#specialOffer").hide();
    }

    period += 1;

    switch (period) {
        case 1:
            period = 4; break;
        case 2:
            period = 6; break;
        case 3:
            period = 12; break;
        case 4:
            period = 24; break;
        case 5:
            period = 36; break;
    }

    $amount.val(accounting.formatNumber($amount.val()));

    var minProfit,
        maxProfit;

    $(".program", ".programs").each(function() {
        var $this = $(this);

        // Если программа подходит под выбранный период
        if (period >= $this.data("min-period") && period <= $this.data("max-period")) {
            // Если период не поддерживает ежемесячную выплату

            if (payments == 3 && $this.data("capitalization") == 0 || payments == 1 && $this.data("monthly-percent") == undefined) {
                $this.hide();
            } else {
                $this.show();
                $(".program__info", $this).show();
            }
        } else {
            if (period == 0) {
                $this.show();
                $(".program__info", $this).hide();
            } else {
                $this.hide();
                $(".program__info", $this).hide();
            }

        }

        var percent = 0,
            percent_real = 0;

        if (payments == 1) {
            percent = getFloat($this.data("monthly-percent")) / 100;
            percent_real = percent;
        } else if (payments == 3) {
            percent_real = getFloat($this.data("capitalization")) / 100;
            percent = Math.pow((percent_real / 12) * 0.9775 + 1, period) - 1;
        } else if (payments == 0 || payments == 2) {
            percent = getFloat($this.data("end-period-percent")) / 100;
            percent_real = percent;
        }

        if (amount >= 1400000) {
            percent += 0.02;
        }

        if (pensioner) {
            percent += 0.015;
            percent_real += 0.015;
        }


        var total = amount + amount * percent / 365 * 30 * period;
        if (payments == 3) {
            total = amount + amount * percent;
        }
        var formatted_total = accounting.formatMoney(total);
        var formatted_profit = accounting.formatMoney(total - amount);

        if (percent_real > 0) {
            percent = percent_real;
        }

        minProfit = minProfit || (total - amount);
        maxProfit = (total - amount);


        $(".program__total", $this).text(formatted_total);
        $(".program__profit", $this).text(formatted_profit);
        $(".program__rate", $this).text(+(percent * 100).toFixed(2) + "%");
    });

    $(".programs__min_profit").text(parseInt(minProfit));
    $(".programs__max_profit").text(parseInt(maxProfit));
}

var getFloat = function(str) {
    return parseFloat(String(str).replace(/,/, "."));
}

$(document).on( "submit", "form", function(e) {
    e.preventDefault();

    var formData = $(this).serialize();

    $.ajax({
        type: "POST",
        url: $(this).attr("action"),
        data: formData
    }).done(function() {
        $.featherlight.close();

        var $alert = $("<div/>")
            .addClass("alert alert-success alert-fixed fade show")
            .append($("<h4/>").addClass("alert-heading").text("Заявка успешно отправлена!"))
            .append($("<p>").text("Ваш личный менеджер свяжется с вами в течение 15 минут."))
            .appendTo("body");

        $alert.alert();

        setTimeout(function() {
            $alert.alert("close");
        }, 3500);
    });
});

